<template>
	<div class="panel-container">
		<slot></slot>
	</div>
</template>

<script>
	import {defineComponent} from "vue"
	
	export default defineComponent({
		name: "panelContainer"
	})
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";
	
	.panel-container{
		height: auto;
		width: 100%;
		@include background_color("panel-container-bg-color");
		border-radius: 6px;
		@include border_all("panel-container-border");
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		box-sizing: border-box;
	}
</style>
